<template>
  <k-page class="page-slides-create">
    <the-slides-create />
  </k-page>
</template>

<script>
/**
 * Component: page-slides-create - Страница создания слайда
*
* @version 1.0.0
*/


// Components
import TheSlidesCreate from '@/components/TheSlidesCreate.vue';
import KPage from '@/components/KPage.vue';


export default {
  name: 'page-slides-create',

  components: {
    KPage,
    TheSlidesCreate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-slides-create {
  $this: &;
}
</style>
